import React from 'react';
import { Paper, Typography, Grid, Box } from '@mui/material';
import { THEME_COLORS, BREAKPOINTS } from '../../constants';

// Iconos de Material-UI
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Componente de estadísticas de suscripciones
 */
const SubscriptionStats = ({ stats }) => {
  const statsData = [
    {
      key: 'total',
      title: 'Total Suscripciones',
      value: stats.total || 0,
      icon: SubscriptionsIcon,
      color: THEME_COLORS.TEXT_PRIMARY,
    },
    {
      key: 'active',
      title: 'Activas',
      value: stats.active || 0,
      icon: CheckCircleIcon,
      color: THEME_COLORS.TEXT_PRIMARY,
    },
    {
      key: 'expiring',
      title: 'Vencen Pronto',
      value: stats.expiring || 0,
      icon: WarningIcon,
      color: THEME_COLORS.TEXT_PRIMARY,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {statsData.map((stat) => {
        const IconComponent = stat.icon;
        
        return (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            md={4} 
            key={stat.key}
          >
            <Paper
              elevation={1}
              sx={{
                p: 2.5,
                height: { xs: 'auto', sm: 120 }, // Altura fija en escritorio, auto en móvil
                display: 'flex',
                alignItems: 'center',
                backgroundColor: THEME_COLORS.BACKGROUND_PAPER,
                border: `1px solid ${THEME_COLORS.BORDER_LIGHT}`,
                cursor: 'default',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: `0 4px 12px ${THEME_COLORS.SHADOW_LIGHT}`,
                },
                [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
                  p: 2,
                  height: 'auto',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    variant="h4"
                    component="div"
                    sx={{
                      fontWeight: 600,
                      color: stat.color,
                      fontSize: { xs: '1.5rem', sm: '2rem' },
                      lineHeight: 1.2,
                      mb: 0.5,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: THEME_COLORS.TEXT_SECONDARY,
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      lineHeight: 1.3,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {stat.title}
                  </Typography>
                </Box>
                
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 48,
                    height: 48,
                    backgroundColor: THEME_COLORS.BACKGROUND_DEFAULT,
                    borderRadius: '12px',
                    border: `1px solid ${THEME_COLORS.BORDER_LIGHT}`,
                  }}
                >
                  <IconComponent
                    sx={{
                      fontSize: 24,
                      color: stat.color,
                    }}
                  />
                </Box>
              </Box>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SubscriptionStats; 